var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Language } from '../../types';
import { useBaseTranslate, useLanguage } from '../../hooks';
import { inputTypeMap } from '../../constants';
var GridifyItem = function (_a) {
    var item = _a.item, selectOptions = _a.selectOptions, download = _a.download;
    var classes = useStyles();
    var language = useLanguage();
    var translate = useBaseTranslate();
    var inputProps = useMemo(function () {
        var _a;
        return ({
            id: item.id.toString(),
            description: "" + (typeof item.description === "string" ? item.description : translate(item.description)) + (item.descriptionQuestion ? "?" : ":") + (item.required ? ' *' : ''),
            options: item.inputType === 'select' ? selectOptions : undefined,
            download: item.download && download ? __assign(__assign({}, download), item.download) : undefined,
            readOnly: (_a = item.readonly) !== null && _a !== void 0 ? _a : undefined
        });
    }, [item, selectOptions, download]);
    var FormComponent = useMemo(function () { var _a; return inputTypeMap[(_a = item.inputType) !== null && _a !== void 0 ? _a : 'text']; }, [item.inputType]);
    if (item.inputType !== 'file' || !item.tooltip || language !== Language.En)
        return (_jsx(FormComponent, __assign({}, inputProps), void 0));
    return (_jsx(Tooltip, __assign({ title: item.tooltip, placement: "top-start", arrow: true, classes: {
            tooltipPlacementTop: classes.tooltip
        } }, { children: _jsx("div", { children: _jsx(FormComponent, __assign({}, inputProps), void 0) }, void 0) }), void 0));
};
export default GridifyItem;
var useStyles = makeStyles({
    tooltip: {
        marginBottom: 5.5
    }
});
//# sourceMappingURL=GridifyItem.js.map